/// \file authRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { Route } from "react-router-dom";

const Signup = lazy(() => import('../views/auth/signup.view'));
const Signin = lazy(() => import('../views/auth/signin.view'));
const CreatePassword = lazy(() => import('../views/auth/createpassword.view'));

const routes = (
  <Route path='auth'>
    <Route
      path='signin'
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <Signin />
        </Suspense>
      }
      handle={{
        text: 'Signin'
      }}
    />
    <Route
      path='signout'
      action={async () => (await import('../views/auth/signout.action')).action() }
    />
    <Route
      path='signup'
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <Signup />
        </Suspense>
      }
      handle={{
        text: 'Signup'
      }}
      />
      <Route
      path='createPassword'
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <CreatePassword />
        </Suspense>
      }
      handle={{
        text: 'Create Password'
      }}
      />
  </Route>
);

export default routes;